import React, { useState } from "react"
import { ReactChildren } from "../../types"
import { CircleUserGear, LogOut } from "../../icons"
import { NavLink } from "react-router-dom"
import { applyTheme, currentTheme, Theme } from "../../libs/theme"

export interface MenuProps {
    setLogout: () => void
    onClick: () => void
    children?: ReactChildren
    logo?: ReactChildren
}

/** Bouton clair / sombre : soleil en mode sombre (pour revenir au clair), lune en mode clair. */
function ThemeToggle() {
    const [theme, setTheme] = useState<Theme>(currentTheme())
    const next: Theme = theme === 'dark' ? 'light' : 'dark'
    const label = theme === 'dark' ? 'Passer en mode clair' : 'Passer en mode sombre'

    return (
        <button
            type="button"
            className="menu-footer-btn"
            title={label}
            aria-label={label}
            onClick={() => { applyTheme(next); setTheme(next) }}
        >
            {theme === 'dark' ? (
                <svg viewBox="0 0 24 24" className="w-[18px] h-[18px]" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round">
                    <circle cx="12" cy="12" r="4" />
                    <path d="M12 2.5v2M12 19.5v2M4.6 4.6 6 6M18 18l1.4 1.4M2.5 12h2M19.5 12h2M4.6 19.4 6 18M18 6l1.4-1.4" />
                </svg>
            ) : (
                <svg viewBox="0 0 24 24" className="w-[18px] h-[18px]" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinejoin="round">
                    <path d="M20.5 14.2A8.5 8.5 0 0 1 9.8 3.5a8.5 8.5 0 1 0 10.7 10.7Z" />
                </svg>
            )}
        </button>
    )
}

export function Menu({
    setLogout,
    onClick,
    children,
    logo,
}: MenuProps) {

    return (
        <nav className="menu">
            {
                logo ?
                    <div className="menu-logo">{logo}</div>
                : null
            }
            <div className="menu-body">
                { children }
            </div>
            <div className="menu-footer">
                <ThemeToggle />
                <NavLink
                    className="menu-footer-btn"
                    to="/profil" title="Mon profil"
                    onClick={onClick}
                >
                    <CircleUserGear className="w-[18px] h-[18px]" />
                    <span className="sr-only">Mon profil</span>
                </NavLink>
                <a
                    className="menu-footer-btn"
                    onClick={ setLogout } title="Déconnexion"
                >
                    <LogOut className="w-[18px] h-[18px]" />
                    <span className="sr-only">Déconnexion</span>
                </a>
            </div>
        </nav>
    )
}
